import { TextAreaProps } from 'antd/lib/input';

import { StyledTextArea } from './styles';

export function UiTextArea(props: TextAreaProps) {
  return <StyledTextArea {...props} />;
}
